import { Action, createReducer, on } from '@ngrx/store';
import { BiometricsState } from './biometrics.state';

import * as biometricsActions from '@store/biometrics/biometrics.actions';

export const initialBiometrics: BiometricsState = {
  step: 1,
  isLoading: false,
  error: null,
  keynuaWidgetResponse: null,
  isBiometrics: false,
};

const _biometricsReducer = createReducer(
  initialBiometrics,
  on(biometricsActions.setBiometricsStep, (state, { step }) => {
    return {
      ...state,
      step,
    };
  }),
  on(biometricsActions.getKeynuaWidgetToken, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(biometricsActions.successGetKeynuaWidgetToken, (state, { keynuaWidgetResponse }) => {
    return {
      ...state,
      step: 2,
      isLoading: false,
      keynuaWidgetResponse,
    };
  }),
  on(biometricsActions.failureGetKeynuaWidgetToken, (state, { error }) => {
    return {
      ...state,
      isLoading: false,
      error,
    };
  }),
  on(biometricsActions.getKeynuaWidgetStatus, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(biometricsActions.successGetKeynuaWidgetStatus, (state, { keynuaWidgetResponse }) => {
    return {
      ...state,
      isLoading: true,
      keynuaWidgetResponse,
    };
  }),
  on(biometricsActions.failureGetKeynuaWidgetStatus, (state, { error }) => {
    return {
      ...state,
      isLoading: false,
      error,
    };
  }),
  on(biometricsActions.resetKeynuaWidgetResponse, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(biometricsActions.setIsBiometricsFlag, (state, { isBiometrics }) => {
    return {
      ...state,
      isBiometrics,
    };
  })
);

export function biometricsReducers(state: BiometricsState | undefined, action: Action) {
  return _biometricsReducer(state, action);
}
